var app = angular.module('leonardo');

var FixedScrollDirective = function() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {

      element.css({position: 'relative'});
      scope.left = element.position().left;

      if (angular.element(window).width() >= 960)
        scope.width = angular.element(window).width() - 330;
      else
        scope.width = angular.element(window).width() - 60;
      element.css({width: scope.width});

      angular.element('.wrapper-columns-column.region-main .content-column').bind("scroll", function() {
        scope.currPosElement = angular.element('.wrapper-columns-column.region-main .content-column').scrollLeft();
        scope.scrollLeft = parseInt(scope.currPosElement);
        if (scope.scrollLeft > 0)
          element.css({left: scope.scrollLeft});
        else
          element.css({left: 0});
      });

      scope.$watch(angular.element('.wrapper-columns-column.region-main .content-column').offsetWidth, function() {
        element.css({left: 0});
        angular.element('.wrapper-columns-column.region-main .content-column').scrollLeft(0);
      });

      scope.$on('$destroy', function() {
        angular.element('.wrapper-columns-column.region-main .content-column').off('scroll', function(){
          // This is intentional do_something blank function
        });
      });

    }
  };
};

app.directive('fixedScroll', [FixedScrollDirective]);
